<template>
  <div class="parc-container">
    <div class="sidemenu d-flex justify-content-center">
      <Sidemenu 
        filterType="contract"
        @filtersChanged="handleFiltersChanged"
      />
      <div class="m-auto text-center d-none">
        <a class="btn btn-purple-inverted m-1" @click="exportParc">
          <fa class="fa" icon="file-export"></fa>
          Générer le parc de contrats
        </a>
        <a v-if="currentFile" class="btn btn-purple-inverted m-1" :href="currentFile"
           :download="'parcContrat_'+new Date()">
          <fa class="fa" icon="file-export"></fa>
          Télécharger le parc de contrats
        </a>
      </div>
    </div>
    <div class="main-content">
      <el-container>
        <el-header class="my-4 h-auto">
          <h3 class="text-uppercase font-weight-bold">Parc de contrats <span class="title-count">({{ contractsCount }})</span></h3>
        </el-header>
        <el-main class="ml-3 p-0">
          <DataTableContract :loading="loading" :contracts="contracts"></DataTableContract>
        </el-main>
      </el-container>
    </div>
  </div>
</template>

<script>

import DataTableContract from "@/components/DataTableContract.vue";
import contractService from "@/services/contract.service";
import {base64ToBlob} from "@/helpers/tools";
import { RECONDUCTION_STATUS_OPTIONS } from "@/utils/reconductionStatusOptions";
import Sidemenu from "@/components/Sidemenu.vue";

export default {
  name: 'Parc',
  components: {Sidemenu, DataTableContract},
  data() {
    return {
      contracts: [],
      loading: false,
      currentTime: Date.now(),
      currentFile: null
    };
  },
  computed: {
    contractsCount() {
      return this.contracts.length;
    }
  },
  methods: {
    handleFiltersChanged(filters) {
      this.loading = true;
      this.getContract(filters);
    },
    exportParc() {
      contractService.exportAllContract().then((response) => {
        this.$notify({
          duration: 5000,
          text: 'Votre document est en cours de préparation',
          type: 'success'
        });
        let blob = base64ToBlob(response.data.content);
        this.currentFile = window.URL.createObjectURL(new File([blob], 'file', {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}));

      }).catch((error) => {
        this.$notify({
          duration: 5000,
          text: error,
          type: 'error'
        });
      });
    },
    preCalculData(contracts) {
      contracts.forEach((contract) => {
        contract.pourcentage_avancement = this.calculPourcentageDate(contract);
        contract.reconductible = this.checkReconductible(contract);
      })
      return contracts;
    },
    calculPourcentageDate(contract) {
      if (this.currentTime > contract.date_fin) {
        return 100;
      }
      if (this.currentTime < contract.date_debut) {
        return 0;
      }
      return Math.round((this.currentTime - contract.date_debut) / (contract.date_fin - contract.date_debut) * 100);
    },
    checkReconductible(contract) {
      if (!contract.financement.taciteReconduction) {
        return RECONDUCTION_STATUS_OPTIONS.find((status) => status.value === 'arret');
      }
      if (contract.financement.taciteReconduction && contract.date_fin < this.currentTime) {
        return RECONDUCTION_STATUS_OPTIONS.find((status) => status.value === 'reconduit');
      }
      if (contract.financement.taciteReconduction && contract.date_fin > this.currentTime) {
        return RECONDUCTION_STATUS_OPTIONS.find((status) => status.value === 'reconductible');
      }
      return 0;
    },
    async getContract(sqlfilter = '') {
      await contractService.getAllContracts(sqlfilter)
          .then((response) => {
            this.contracts = this.preCalculData(response.data)
          }).catch(() => {
            this.$notify({
              duration: 5000,
              text: 'Erreur lors de la récupération des contracts',
              type: 'error'
            })
          }).finally(() => {
            this.loading = false;
          })
    }
  },
  async mounted() {
    this.currentTime = Math.round(this.currentTime / 1000)
    this.loading = true;
  }
};
</script>

<style scoped>
.sidemenu {
  position: fixed;
  top: 50%;
  transform: translateY(-50%);
  margin-left: 1rem;
  width: 21rem;
  z-index: 1000;
  overflow-y: auto;
}

.main-content {
  width: calc(100% - 28rem);
  margin-left: 23rem;
}

</style>
